/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import NFFilter from '../components/FilterContainer';
import FilterForm from '../components/FilterForm';
import {
  DATE_FILTERS,
  dateFilterToDays,
  PERIOD_FILTERS,
} from '../enums';

import {
  Container,
  FormLabelStyled,
  RadioStyled,
  RadioGroupStyled,
  FormControlStyled,
  LabelStyled,
  DateContainer,
  DividerStyled,
} from '../styles';
import RangeDatePicker from '../../../../../components/RangeDatePicker';

const DateFilter = ({
  isOpen,
  onClick,
  onApply,
  byDate,
  initialPeriod,
  finalPeriod,
}) => {
  const [selectedItemByDate, setSelectedItemByDate] = useState(byDate);
  const [startDate, setStartDate] = useState(initialPeriod);
  const [endDate, setEndDate] = useState(finalPeriod);

  const handleChangeByDate = e => {
    setSelectedItemByDate(e.target.value);
  };

  const handleSubmit = e => {
    e.preventDefault();

    onApply({
      byDate: selectedItemByDate,
      initialDate: startDate,
      finalDate: endDate,
    });
  };

  return (
    <NFFilter label={PERIOD_FILTERS.CUSTOM} isOpen={isOpen} onClick={onClick}>
      <FilterForm
        label="Filtrar por data"
        onSubmit={handleSubmit}
        dontShowClearButton
      >
        <Container>
          <FormControlStyled>
            <RadioGroupStyled
              value={selectedItemByDate || dateFilterToDays.BY_CONTRACTED_TERM}
              onChange={handleChangeByDate}
            >
              <FormLabelStyled
                value={dateFilterToDays.BY_SOLICITATION}
                control={<RadioStyled />}
                label={<LabelStyled component="span">{DATE_FILTERS.BY_SOLICITATION}</LabelStyled>}
              />
              <FormLabelStyled
                value={dateFilterToDays.BY_CONTRACTED_TERM}
                control={<RadioStyled />}
                label={<LabelStyled component="span">{DATE_FILTERS.BY_CONTRACTED_TERM}</LabelStyled>}
              />
            </RadioGroupStyled>
          </FormControlStyled>
          <DividerStyled />
          <DateContainer>
            <RangeDatePicker
              startDate={startDate}
              endDate={endDate}
              onChangeStartDate={setStartDate}
              onChangeEndDate={setEndDate}
              customPeriods={[
                { key: 'LAST_30', label: '30 dias', days: 30 },
                { key: 'LAST_60', label: '60 dias', days: 60 },
                { key: 'LAST_90', label: '90 dias', days: 90 },
              ]}
            />
          </DateContainer>
        </Container>
      </FilterForm>
    </NFFilter>
  );
};

const mapStateToProps = state => ({
  byDate: state.tracking.filters.byDate,
  initialPeriod: state.tracking.filters.initialPeriod,
  finalPeriod: state.tracking.filters.finalPeriod,
});

export default connect(mapStateToProps)(DateFilter);